import { processChartLayout } from "../../InitialRenderingData";

export const getInitialConfigForChartBlock = (config, options) => {
  const chartConfig = JSON.parse(JSON.stringify(config));

  const newFilters = getUpdatedChartColumnAndFilters(chartConfig.config.global_filters, options.tableData);
  const w = getUpdatedChartsLayout(chartConfig.config.charts, options.tableData);
  const newCharts = processChartLayout(w.layout, w.layoutData);
  chartConfig.config.global_filters = newFilters;
  chartConfig.config.charts = newCharts;
  return {
    config: chartConfig,
    options: {
      chartLayout: w
    }
  };
};

const getUpdatedChartColumnAndFilters = (global_filters, tableData) => {
  const { tableObject } = tableData;

  // handle global filter
  const { fields, pre_filters } = global_filters;
  const newFields = [];
  fields.forEach((field) => {
    if (tableObject[field.id]) {
      newFields.push({ ...field, ...tableObject[field.id] });
    }
  });

  const newPrefilter = [];
  pre_filters.forEach((field) => {
    if (tableObject[field.id]) {
      newPrefilter.push({ ...field, ...tableObject[field.id] });
    }
  });

  return {
    ...global_filters,
    fields: newFields,
    pre_filters: newPrefilter
  };
};

const getUpdatedChartsLayout = (charts, tableData) => {
  const { tableObject } = tableData;

  const layout = [];
  const layoutData = {};

  // handle charts
  charts.forEach((chart) => {
    const { grid, element_config } = chart;
    layout.push(grid);

    // handle group columns
    const newGroupColumn = [];
    element_config.group_columns.forEach((col) => {
      if (tableObject[col.column]) {
        newGroupColumn.push({ ...col, ...tableObject[col.column] });
      }
    });

    //   handle aggregate column
    const newAggregateColumn = tableObject[element_config.aggregate_column]?.id || "";

    const newConfig = {
      ...element_config,
      group_columns: newGroupColumn,
      aggregate_column: newAggregateColumn
    };

    layoutData[grid.i] = newConfig;
  });
  return { layout, layoutData };
};
